import { AnimatePresence, motion } from "framer-motion";

import {
    Flex,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay
} from "@chakra-ui/react";

import { DotLoader } from "@components/DotLoader";
import { Text } from "@components/Text";

const PageLoader = () => {
    return (
        <Modal closeOnOverlayClick={false} isOpen onClose={() => {}} isCentered>
            <ModalOverlay />
            <ModalContent justifyContent="center" alignItems="center" p={10}>
                <ModalBody p={0}>
                    <Flex gap={6}>
                        <DotLoader size="lg" />
                        <AnimatePresence>
                            <motion.div
                                animate={{
                                    opacity: [1, 0.6, 1]
                                }}
                                transition={{
                                    repeat: Infinity,
                                    duration: 2,
                                    ease: "easeInOut"
                                }}
                            >
                                <Text type="subHeading">Loading. . .</Text>
                            </motion.div>
                        </AnimatePresence>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default PageLoader;
